import { Package, ImageIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ProductThumbnailProps {
  imageUrl?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showPlaceholder?: boolean;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
};

const iconSizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export const ProductThumbnail = ({
  imageUrl,
  name,
  size = 'md',
  className,
  showPlaceholder = true,
}: ProductThumbnailProps) => {
  if (imageUrl) {
    return (
      <div className={cn('relative overflow-hidden rounded-md', sizeClasses[size], className)}>
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback to placeholder if image fails to load
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent) {
              parent.innerHTML = `
                <div class="w-full h-full bg-muted flex items-center justify-center">
                  <svg class="h-4 w-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                  </svg>
                </div>
              `;
            }
          }}
        />
      </div>
    );
  }

  if (showPlaceholder) {
    return (
      <div className={cn(
        'bg-muted flex items-center justify-center rounded-md',
        sizeClasses[size],
        className
      )}>
        <Package className={cn('text-muted-foreground', iconSizeClasses[size])} />
      </div>
    );
  }

  return null;
};